import React, {useEffect, useState} from 'react';
import RowInventory from "./RowInventory";

const MapComponent = ({data, selectedLocation,svg}) => {
    const [openModal, setOpenModal] = useState(false)
    const [id, setId] = useState()


    useEffect(() => {
        let item;
        let itemFull = 0;
        let itemText;
        let groupElement; // get <g> tag

        data.rowsInMap.forEach(({ matchNumber, id, count, maxCapacity, name ,isMain}) => {
            let isMainRow = isMain;

            groupElement = document.getElementById(isMainRow ? "Main" : name);
            item = groupElement?.getElementsByTagName("rect")[0];
            itemFull = groupElement?.getElementsByTagName("rect")[1];
            itemText = groupElement?.getElementsByTagName("text")[isMainRow ? 0 : 1];
            let percentNumber = count/ maxCapacity;
            let percent = (percentNumber < 0.05 && percentNumber > 0) ? 0.05 : percentNumber > 1 ? 1 : percentNumber;

            if (itemText && itemFull) {
                let itemFullHeight = itemFull.height.animVal.value;

                //itemFull.style.fill = 'transparent';

                if (matchNumber > 0) {
                    itemFull.style.cursor = 'pointer';
                    itemText.style.cursor = 'pointer';
                    groupElement?.addEventListener("click", () => {
                        setId(id);
                        setOpenModal(true);
                    });
                }

                if (!isMainRow) {
                    item.style.height = `${itemFullHeight * 0}px`;
                    item.style.fill = (data.isFilter && !matchNumber) ? 'gray' : percentNumber > 1 ? 'var(--red)' : 'var(--blue)';
                }
                itemText.innerHTML = `${data.isFilter && matchNumber ? `(${matchNumber})` : ''} ${count} `;
            }
        });
    }, [svg, data]);




    return (<div id='alphasvg'>
        <RowInventory selectedLocation={selectedLocation} id={id} openModal={openModal} setOpenModal={setOpenModal}/>
        <div className={'mapBoxContainer'}
             dangerouslySetInnerHTML={{__html: svg}}/>


    </div>);
};

export default MapComponent;